// extracted by mini-css-extract-plugin
export default {"user-information":"TabStatistics_user-information__vmTdh","user-information-wrapper":"TabStatistics_user-information-wrapper__ItEOc","callendar":"TabStatistics_callendar__fWG2f"};